export default __webpack_public_path__ + "static/media/about.aee0f771.png";